import React, {useState} from 'react';
// import MaterialTable from "material-table";
import {tablePageRowsRate, defaultRowsRate} from '../../constants/ReusableTablePagination';
import {tableIcons} from '../../components/TableIcons';
import DialogBox from '../../components/DialogBox';
import EditSubscribedServices from './EditSubscribedServices';
import GuiTable from '../../components/FormComponents/GuiTable';

function RateTables(props) {
  const [rowData, setRowData] = useState(false);
  const [open, setOpen] = useState(false);
  const columns = [
    {title: 'Sub Service Type', field: 'subServiceType', editable: 'never'},
    {title: 'Rate Type', field: 'rateType', editable: 'never'},
    {title: 'Amount', field: 'amount', editable: 'never'},
    {title: 'Percentage', field: 'percentage', editable: 'never'},
    {title: 'Effective Date', field: 'effectiveDate', editable: 'never'},
    {title: 'End Date', field: 'endDate'},
  ];
  const data = [
    {
      id: 4, // MAIN ELEMENT
      subServiceType: 'Outpatient Medicaid Approved Applications',
      rateType: 'Flat',
      amount: '624.00',
      percentage: '',
      effectiveDate: '01/08/2018',
      endDate: '',
      parentId: 10,
    },
    {
      id: 1, // MAIN ELEMENT
      subServiceType: 'Inpatient Medicaid Approved Applications',
    },
    {
      id: 2, // CHILD OF THE MAIN ELEMENT
      subServiceType: 'Inpatient Medicaid Approved Applications',
      rateType: 'Flat',
      amount: '350.00',
      percentage: '',
      effectiveDate: '01/08/2018',
      endDate: '12/31/2018',
      parentId: 1,
    },
    {
      id: 3, // CHILD OF THE MAIN ELEMENT
      subServiceType: 'Inpatient Medicaid Approved Applications',
      rateType: 'Flat',
      amount: '200.00',
      percentage: '',
      effectiveDate: '01/08/2018',
      endDate: '12/31/2018',
      parentId: 1,
    },
  ];
  const handleClose = () => {
    setOpen(false);
    setRowData({});
  };
  const handleEditRow = (data) => {
    setRowData(data);
    setOpen(true);
  };

  return (
    <>
      <DialogBox open={open} title="Edit" dialogClose={handleClose}>
        <EditSubscribedServices rowData={rowData} />
      </DialogBox>
      <div className="custom-table ">
        <GuiTable
          columns={columns}
          data={data}
          title=""
          parentChildData={(row, rows) => {
            return rows.find((v) => v.id === row.parentId);
          }}
          icons={tableIcons}
          options={{
            filtering: false,
            pageSize: defaultRowsRate,
            pageSizeOptions: tablePageRowsRate,
            search: true,
            emptyRowsWhenPaging: false,
          }}
          actions={[
            (rowData) => ({
              icon: 'edit',
              tooltip: 'Edit',
              hidden: !rowData?.parentId,
              disabled: rowData?.endDate,
              onClick: (event, rowData) => {
                handleEditRow(rowData);
              },
            }),
          ]}
        />
      </div>
    </>
  );
}

export default RateTables;
